export default __webpack_public_path__ + "static/0049-324eb7fa2c8cb0756e4b355ae1db8462.png";